import copy from "copy-to-clipboard";
import { useCallback, useEffect, useRef, useState } from "react";

/** The things on the page that can be copied. */
export type Pp2CopyKey = "bank" | "address";

/**
 * The page's single "copied" state (spec 5.4/5.5): a copy shows its feedback for
 * COPY_FEEDBACK_MS, and a new copy restarts the timer and clears the other copy's feedback.
 */
export type Pp2CopyFeedback = {
  copiedKey: Pp2CopyKey | null;
  copy: (key: Pp2CopyKey, text: string) => void;
};

export const COPY_FEEDBACK_MS = 1500;

export function useCopyFeedback(): Pp2CopyFeedback {
  const [copiedKey, setCopiedKey] = useState<Pp2CopyKey | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  useEffect(
    () => () => {
      clearTimeout(timer.current);
    },
    [],
  );

  const copyText = useCallback((key: Pp2CopyKey, text: string): void => {
    copy(text);
    setCopiedKey(key);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      setCopiedKey(null);
    }, COPY_FEEDBACK_MS);
  }, []);

  return { copiedKey, copy: copyText };
}
